(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-side-cart"]) return;
  try {
    
  if (!customElements.get('dj-pet-quick-add')) {
    customElements.define('dj-pet-quick-add', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelector('form').addEventListener('submit', event => this.add(event));
      }
      async add(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.busy || this.constructor.pending) return;
        this.constructor.pending = true;
        document.querySelectorAll('dj-pet-quick-add button').forEach(control => { control.disabled = true; });
        this.busy = true;
        const form = event.currentTarget;
        const button = form.querySelector('button');
        const label = button.querySelector('[data-pet-add-label]');
        const originalLabel = label.textContent;
        const error = this.querySelector('[data-pet-add-error]');
        const drawer = this.closest('#cart');
        const sectionId = drawer.dataset.sectionId;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = this.dataset.loading;
        error.hidden = true;
        const root = window.Shopify?.routes?.root || '/';
        let added = false;
        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: 1 }], sections: [sectionId], sections_url: window.location.pathname }),
            signal: AbortSignal.timeout(15000)
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          added = true;
          if (window.ajaxCart?.load) {
            window.ajaxCart.load(result.sections?.[sectionId] ? result : false, true, false, !result.sections?.[sectionId]);
          } else {
            window.location.assign(root + 'cart');
          }
        } catch (failure) {
          if (added) {
            window.location.assign(root + 'cart');
            return;
          }
          error.textContent = failure.name === 'TimeoutError' ? this.dataset.error : failure.message || this.dataset.error;
          error.hidden = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          label.textContent = originalLabel;
          this.busy = false;
        } finally {
          this.constructor.pending = false;
          document.querySelectorAll('dj-pet-quick-add').forEach(card => {
            if (!card.busy) card.querySelector('button').disabled = false;
          });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
